// extracted by mini-css-extract-plugin
export default {"job_admin":"JobAdmin_job_admin__TTWIO","left":"JobAdmin_left__PYdqo","right":"JobAdmin_right__oQ2nc"};